import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadWidgetCriteria {
    widgetId: string;
}

class ReadWidgetCriteriaImpl implements ReadWidgetCriteria {
    constructor(readonly widgetId: string) {}
}

export class ReadWidgetCriteriaBuilder {
    private widgetId: Option<string> = none;

    static create = (): ReadWidgetCriteriaBuilder => new ReadWidgetCriteriaBuilder();

    withWidgetId = (widgetId: string): ReadWidgetCriteriaBuilder => {
        this.widgetId = some(widgetId);
        return this;
    };

    build = (): ReadWidgetCriteria => {
        if (isNone(this.widgetId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadWidgetCriteriaImpl(this.widgetId.value);
    };
}
